import { FC, useState, useEffect } from 'react';
// import { useBidRange } from '../../Hooks/useBidRange';
import { RsNumberInput } from 'components/Rsuite/Input';
import { Form } from 'rsuite';
import { useOrderStore } from 'store/orderStore';

interface MaxBidProps {
  maxBid: string;
  currency: string;
  MaxBidError: string;
  onMaxBidChange: (v: string) => void;
}

export const MaxBid: FC<MaxBidProps> = ({
  maxBid,
  onMaxBidChange,
  currency = '',
  MaxBidError,
}) => {
  // const bidRange = useBidRange();
  const { order } = useOrderStore();

  const [bidFloor_cpm, setBidFloor_cpm] = useState(0);

  useEffect(() => {
    const display =
      order?.campaignBidPrice?.find((item) => item.type === 'DISPLAY') ||
      undefined;
    // const bidFloor_cpm = display?.bidFloor?.cpm
    if (display) {
      setBidFloor_cpm(display?.bidFloor?.cpm || 0);
    }
  }, [order]);

  return (
    <div className='flex flex-col gap-[14px]'>
      <div className='flex items-center gap-[16px]'>
        <RsNumberInput
          className='max-w-[165px]'
          num={maxBid}
          onChange={onMaxBidChange}
        />

        <span>元 / 千次曝光</span>
      </div>
      <Form.ErrorMessage
        show={MaxBidError !== undefined}
        placement='topEnd'
        className='mr-[200px]'
      >
        {MaxBidError}
      </Form.ErrorMessage>
      {/* <span className='text-[#808080]'> */}
      {/* <Form.HelpText className='!w-[30rem]'>
        金額請高於 {currency} {bidFloor_cpm} 元以上
      </Form.HelpText> */}
    </div>
  );
};
